/* CF山梨: トップページ各セクションのスクロール演出(Step11)
   - .cf-reveal を画面進入時に静かにフェードアップ
   - 安全策: JSがセクション直下に data-cf-anim を付けたときだけCSSが隠す。
     JS無効・JSエラー・reduced-motion では内容は常時表示(消えない)
   - 複数セクションが本スクリプトを読み込むため二重初期化をガード */
(function () {
  if (window.__cfHomeRevealInit) return;
  window.__cfHomeRevealInit = true;

  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  function boot() {
    if (reduce || !hasIO) return;
    var roots = document.querySelectorAll(
      '.cf-home-news, .cf-home-match, .cf-home-tiles, .cf-home-sponsors'
    );
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    roots.forEach(function (root) {
      var items = root.querySelectorAll('.cf-reveal');
      if (!items.length) return;
      root.setAttribute('data-cf-anim', '');
      items.forEach(function (el, i) {
        el.style.transitionDelay = Math.min(i, 5) * 70 + 'ms';
        io.observe(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
